module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/J_10_9@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-paytable/J_10_9@3x.png
// module id = 706
// module chunks = 0